import * as _ from 'underscore'

import { DataProvider, LogHelper, ConvertHelper, ToastHelper } from "../helpers"

import { OpFile, OpSupplier } from "../models/core"
import { Enums } from "../models/common"
import { ColumnInfo } from "../models/custom"
import { DataProviderRequest } from './utils'

export class DataProviderSupplier {

    // #region Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.DataProvider.Supplier]' }

    // #endregion Consts End


    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion Ctor End    

    // #region Delete    

    public deleteSupplier = (idSupplier: number): JQueryPromise<void> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeleteSupplier', { IdSupplier: idSupplier }, null)
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })
    }

    // #endregion

    // #region Get

    public getSupplier = (id: number): DataProviderRequest<OpSupplier> => {
        const promise: JQueryPromise<OpSupplier> = this.dataProvider
            .sendRequestWithSession('OpxGetSupplier', { IdSupplier: id }, 'OpxGetSupplierResult')
            .then((response: any) => {
                const supplier: OpSupplier = new OpSupplier(response)

                return supplier
            })
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getSupplierFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpSupplier>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdSupplier, 'OpxSupplierFilter', 'OpxSupplierFilterResult')
    }

    // #endregion

    // #region Save

    public saveSupplier = (opObj: OpSupplier): JQueryPromise<OpSupplier> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveSupplier', { ToBeSaved: opObj.toJSON() }, 'OpxSaveSupplierResult')
            .then((response: any) => {
                const supplier: OpSupplier = new OpSupplier(response)

                // return OpSupplier.loadNavigationProperties(this.dataProvider, [task])
                //     .then((tasks: OpTask[]) => {
                //         return _.first(tasks)
                //     })

                return supplier
            })
    }

    public saveSupplierLogo = (idSupplier: number, file: OpFile): JQueryPromise<OpFile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveSupplierLogo', { IdSupplier: idSupplier, file: file.toJSON() }, 'OpxSaveSupplierLogoResult')
            .then((response: any) => new OpFile(response))
    }

    public getSupplierLogo = (idSupplier: number): JQueryPromise<OpFile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetSupplierLogo', { IdSupplier: idSupplier }, 'OpxGetSupplierLogoResult')
            .then((response: any) => {
                if (response != null) {
                    return new OpFile(response)
                }

                return null
            })
    }

    public saveSupplierMessageFile = (idSupplier: number, file: OpFile, idLanguage: number): JQueryPromise<OpFile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveSupplierMessageFile', { IdSupplier: idSupplier, File: file.toJSON(), Idlanguage: idLanguage }, 'OpxSaveSupplierMessageFileResult')
            .then((response: any) => new OpFile(response))
    }
    // #endregion
}